module.exports = __webpack_public_path__ + "static/media/tab-8bit-crunchy.8c2da893.png";